import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';
import { Publication } from 'app/fs/res/publication/model/publication';
import { PublicationCreator } from 'app/fs/res/publication/model/publication-creator';

import { HisUiService, HisBaseGlobalsService, HisNotificationService } from 'hisng';

class PublicationCreatorView extends PublicationCreator {
    label: string;
}

@Component( {
    selector: 'res-publication-contact-dialog',
    templateUrl: './publication-contact-dialog.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationContactDialogComponent)],
} )
export class PublicationContactDialogComponent implements OnInit {
    @Input() creator: PublicationCreator;
    @Input() publication: Publication;
    @Input() visibility: boolean;
    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();
    @Output() creatorChange: EventEmitter<PublicationCreator> = new EventEmitter();

    public filteredCreators: PublicationCreatorView[];
    selectedCreator: PublicationCreatorView;
    email: string;

    constructor( private hisUiService: HisUiService,
        private hisBaseGlobalsService: HisBaseGlobalsService,
        private notificationService: HisNotificationService ) { }

    ngOnInit() {
        this.filterCreators({query: ''});
        if (this.creator?.person?.id) {
            this.selectedCreator = this.filteredCreators.find(c => c.person.id === this.creator.person.id);
            this.email = this.selectedCreator.email;
        }
    }

    public filterCreators( event: { query: string } ) {
        this.filteredCreators = [];
        this.publication.creators?.filter(c => !c.isPublicationContact || c.person?.id === this.creator?.person?.id).forEach( creator => {
            if ( creator.person && (creator.person?.firstname + ' ' + creator.person?.surname).toLowerCase().indexOf( event.query.toLowerCase() ) === 0 ) {
                this.filteredCreators.push( {...creator, label: creator.person.firstname + ' ' + creator.person.surname} );
            }
        } );
    }

    public closeDialog() {
        this.visibilityChange.emit(false);
    }

    public applyChanges() {
        let messages = this.getValidationMessages();
        if ( messages.length !== 0 ) {
            this.notificationService.error(
                messages,
                this.hisUiService.translate('global.validationerror')
            );
        } else {
            this.selectedCreator.isPublicationContact = true;
            this.selectedCreator.email = this.email;
            delete this.selectedCreator.label;
            this.creatorChange.emit(this.selectedCreator);
            this.closeDialog();
        }
    }

    private getValidationMessages() {
        let messages: any[] = [];
        let inputRequired = this.hisUiService.translate('validation.required');
        let ddKeyRequiredCreator =
            this.hisBaseGlobalsService.getDd('fs.res.publication.PublicationContact.publicationCreator');
        let ddKeyRequiredEmail = this.hisBaseGlobalsService.getDd('fs.res.publication.PublicationContact.email');

        if ( ddKeyRequiredCreator?.required && !ddKeyRequiredCreator?.hidden && !this.selectedCreator ) {
            messages.push(`${this.hisUiService.translate(
                'fs.res.publication.PublicationContact.publicationCreator')}: ${inputRequired}`);
        }
        if ( ddKeyRequiredEmail?.required && !ddKeyRequiredEmail?.hidden && !this.email?.length ) {
            messages.push(`${this.hisUiService.translate(
                'fs.res.publication.PublicationContact.email')}: ${inputRequired}`);
        }
        return messages;
    }
}
